import { Box } from "@chakra-ui/react";
import OpportunitiesIcon from "../../components/Icons/OpportunitiesIcon";
import StrengthsIcon from "../../components/Icons/StrengthsIcon";
import ThreatsIcon from "../../components/Icons/ThreatsIcon";
import WeaknessesIcon from "../../components/Icons/WeaknessesIcon";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientSWOT } from "../../actions/client/clientActions";
import Loader from "../../components/Loader/Loader";
import BlurSection from "../../shared/BlurSection/BlurSection";

const Metric = ({ text, variant = "default" }) => {
  const baseStyle = {
    padding: "4px 6px",
    borderRadius: "4px",
    fontSize: "12px",
    display: "inline-block",
    margin: "4px",
    backgroundColor: "#f3f4f6",
    color: "#1f2937",
  };

  const variantStyles = {
    default: {},
    green: {
      backgroundColor: "#064e3b",
      color: "#ffffff",
    },
    red: {
      backgroundColor: "#7f1d1d",
      color: "#ffffff",
    },
    warning: {
      backgroundColor: "#fff7ed",
      color: "#9a3412",
      border: "1px solid #fdba74",
    },
  };

  return (
    <span style={{ ...baseStyle, ...variantStyles[variant] }}>{text}</span>
  );
};

const SectionTitle = ({ text, icon }) => (
  <Box
    style={{
      backgroundColor: "#4b5563",
      color: "white",
      padding: "8px 16px",
      marginBottom: "12px",
      borderRadius: "4px",
      display: "flex",
      justifyContent: "center",
      gap: "8px",
    }}
  >
    {icon}
    <span style={{ fontWeight: 500 }}>{text}</span>
  </Box>
);

const SWOTView = ({ clientId }) => {
  console.log("=SWOTView==clientId", clientId);
  const dispatch = useDispatch();

  const { loading, data, modulesAccess: swotViewModule } = useSelector((state) => state.clientSWOTReducer);

  console.log("===swotViewModule", swotViewModule);
  useEffect(() => {
    if (clientId) {
      dispatch(getClientSWOT(clientId));
    }
  }, [clientId, dispatch]);
  console.log("=SWOTView==loading, data", loading, data);
  const containerStyle = {
    maxWidth: "1200px",
    padding: "16px",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "16px",
  };

  const sectionStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const metricsContainerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "2px",
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div style={containerStyle}>
          {/* Strengths Section */}

          <div style={sectionStyle}>
            <SectionTitle text="Strengths" icon={<StrengthsIcon />} />
            <div style={{ position: "relative" }}>
              <div style={metricsContainerStyle}>
                {data?.strengths &&
                  data.strengths.map((strength) => (
                    <Metric
                      text={`${strength.param} - ${strength.status} - ${strength.growth}`}
                    />
                  ))}
              </div>
              {swotViewModule &&
                swotViewModule?.["Strengths"] &&
                swotViewModule["Strengths"]?.["showBlur"] && (
                  <BlurSection height={"100%"} width={"100%"} />
                )}
            </div>
          </div>

          {/* Weaknesses Section */}
          <div style={sectionStyle}>
            <SectionTitle text="Weaknesses" icon={<WeaknessesIcon />} />
            <div style={{ position: "relative" }}>
              <div style={metricsContainerStyle}>
                {data?.weaknesses &&
                  data.strengths.map((weakness) => (
                    <Metric
                      text={`${weakness.param} - ${weakness.status} - ${weakness.growth}`}
                      variant="warning"
                    />
                  ))}
              </div>
              {swotViewModule &&
                swotViewModule?.["Weaknesses"] &&
                swotViewModule["Weaknesses"]?.["showBlur"] && (
                  <BlurSection height={"100%"} width={"100%"} />
                )}
            </div>
          </div>

          {/* Opportunities Section */}
          <div style={sectionStyle}>
            <SectionTitle text="Opportunities" icon={<OpportunitiesIcon />} />
            <div style={{ position: "relative" }}>
              <div style={metricsContainerStyle}>
                {data?.opportunities &&
                  data.strengths.map((opportunity) => (
                    <Metric
                      text={`${opportunity.param} - ${opportunity.status} - ${opportunity.growth}`}
                      variant="warning"
                    />
                  ))}
              </div>
              {swotViewModule &&
                swotViewModule?.["Opportunities"] &&
                swotViewModule["Opportunities"]?.["showBlur"] && (
                  <BlurSection height={"100%"} width={"100%"} />
                )}
            </div>
          </div>

          {/* Threats Section */}
          <div style={sectionStyle}>
            <SectionTitle text="Threats" icon={<ThreatsIcon />} />
            <div style={{ position: "relative" }}>
              <div style={metricsContainerStyle}>
                {data?.threats &&
                  data.strengths.map((threat) => (
                    <Metric
                      text={`${threat.param} - ${threat.status} - ${threat.growth}`}
                      variant="warning"
                    />
                  ))}
              </div>
              {swotViewModule &&
                swotViewModule?.["Threats"] &&
                swotViewModule["Threats"]?.["showBlur"] && (
                  <BlurSection height={"100%"} width={"100%"} />
                )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SWOTView;
